export const appDevelopment = process.env.REACT_APP_IS_PRODUCTION === "false" ? true : false;